import styled, { keyframes } from "styled-components";
import { primaryColor, primaryColorHover, errorColor, bodyColor } from "../../../../config/constants";
import { fadeInDown, fadeInRight } from "react-animations";
import { inputCheckboxIndex } from "../../../../config/zIndex";
import DatePicker from "react-datepicker";
import ReactTooltip from "react-tooltip";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;

export const Container = styled.div`
  margin: 10px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
  border-radius: 5px;
  border-left: ${({ borderLeft }) => `8px ${borderLeft} solid`};
  animation: 0.4s ${fadeInDownAnimation};
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
    height: 85%;
    overflow: scroll;
  }
`;
export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  @media (max-width: 910px) {
    padding: 10px 0;
  }
`;
export const HeaderText = styled.p`
  padding: 0 20px;
  width: ${({ width }) => width && width};
  height: 100%;
  font-size: 16px;
  color: #000;
  display: flex;
  align-items: center;
  border-right: 2px #e6e6e6 solid;
  @media (max-width: 910px) {
    display: ${({ showAlways }) => !showAlways && "none"};
    border: none;
  }
`;
export const HeaderStatus = styled.p`
  padding: 0 20px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ color }) => color && color};
  @media (max-width: 910px) {
    display: none;
  }
`;
export const DisplayCanvasButton = styled.button`
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: none;
  border-radius: 0px 5px 5px 0px;
  border-left: 2px #e6e6e6 solid;
  cursor: pointer;
  position: absolute;
  right: 0;
`;
export const DisplayCanvasImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const DataDiv = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-around;
  border-top: ${({ addTopBorder }) => addTopBorder && "2px #e6e6e6 solid"};
  border-bottom: ${({ addBottomBorder }) => addBottomBorder && "2px #e6e6e6 solid"};
  animation: 0.4s ${fadeInDownAnimation};
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 910px) {
    width: auto;
    align-items: center;
  }
`;
export const InputDataDiv = styled.div`
  width: ${({ width }) => width && width};
  margin-bottom: 15px;
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  justify-content: flex-end;
  animation: ${({ activeAnimation }) => activeAnimation && fadeInRightAnimation};
  animation-duration: 0.3s;
  @media (max-width: 910px) {
    width: auto;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
  text-align: right;
`;
export const Input = styled.input`
  padding: ${({ padding }) => (padding ? padding : "5px 10px")};
  width: 200px;
  border: ${({ error }) => (error ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`)};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const DescriptionText = styled.i`
  width: 100%;
  font-size: 14px;
  color: #808080;
  text-align: left;
  @media (max-width: 910px) {
    font-size: 12px;
  }
`;
export const Textarea = styled.textarea`
  padding: 5px 10px;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  min-height: 150px;
  max-height: 180px;
  border: 1px solid #e6e6e6;
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const RecurringMessageButton = styled.button`
  width: 60px;
  height: 30px;
  display: flex;
  align-items: center;
  background-color: ${({ disabled, showOnlyOnce }) => (disabled ? "#999" : showOnlyOnce ? "#ccc" : "#39b54a")};
  border: none;
  outline: none;
  border-radius: 50px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
  position: relative;
`;
export const RecurringMessageBall = styled.div`
  width: 40%;
  height: 80%;
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
  left: ${({ showOnlyOnce }) => (showOnlyOnce ? "6.666666666666667%" : "53.333333333333336%")};
  transition: 0.2s;
`;
export const PrescriptionDaysDiv = styled.div`
  margin-bottom: 15px;
  width: 280px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
`;
export const FlexDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
export const SelectAllText = styled.p`
  font-size: 14px;
  color: #808080;
  @media (max-width: 910px) {
    font-size: 12px;
  }
`;
export const SelectAllButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const SelectAllImg = styled.img`
  width: 24px;
  height: 24px;
`;
export const PrescriptionsSeparator = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e6e6e6;
`;
export const DayText = styled.label`
  font-size: 14px;
  color: #808080;
  @media (max-width: 910px) {
    font-size: 12px;
  }
`;
export const InputCheckboxDiv = styled.div`
  width: 23px;
  height: 23px;
  position: relative;
`;
export const InputCheckbox = styled.input`
  width: 23px;
  height: 23px;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const VerifyCheckboxImg = styled.img`
  width: 23px;
  height: 23px;
  position: absolute;
`;
export const DateInputDiv = styled.div`
  width: 200px;
`;
export const DateInput = styled(DatePicker)`
  padding: 5px 10px;
  width: 100%;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const ActionButtonsDiv = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 910px) {
    flex-direction: column;
  }
`;
export const SaveButton = styled.button`
  margin: 0 10px;
  padding: 10px 20px;
  background-color: ${primaryColor};
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    margin-bottom: 10px;
    width: 180px;
  }
`;
export const CancelButton = styled.button`
  margin: 0 10px;
  padding: 10px 20px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  @media (max-width: 910px) {
    margin-bottom: 10px;
    width: 180px;
  }
`;
export const DeleteButton = styled.button`
  margin: 0 10px;
  padding: 0 15px;
  height: 38px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${errorColor};
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  @media (max-width: 910px) {
    width: 180px;
  }
`;
export const DeleteImg = styled.img`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;
export const DeleteText = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: ${errorColor};
`;
export const ReactTooltipStyled = styled(ReactTooltip)`
  max-width: 500px;
  border-radius: 5px !important;
  padding: 15px !important;
`;
